import './App.css';

import {Route, Routes, Navigate} from "react-router-dom";
import Home from './en/Home';
import ImageDownloader from './en/Image Downloader/ImageDownloader';
import Print from './en/print/Print';
import PrintWithoutImages from './en/print without images/PrintWithoutImages';
import NoSwipe from './en/No Swipe/NoSwipe';
import NavBar from './en/NavBar';
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import UninstallSurvey from './en/UninstallSurvey';
import UninstallSurveyGeneral from './UninstallSurveyGeneral';
import PrintRateUs from './en/print/PrintRateUs';
//import PrintRateUs from './PrintRateUs';
import ImageDownloaderRateUs from './ImageDownloaderRateUs';
import NoSwipeRateUs from './NoSwipeRateUs';
import NoSwipeGetCode from './NoSwipeGetCode';
import ImageDownloaderGetCode from './ImageDownloaderGetCode';
import SpongeColorPicker from './SpongeColorPicker';
import PrintReview from './PrintReview';
import PrintWithoutImagesReview from './PrintWithoutImagesReview';
import ImageDownloaderGeneral from './ImageDownloader/ImageDownloaderGeneral';
import ImageDownloaderPrivacyPolicy from './ImageDownloader/ImageDownloaderPrivacyPolicy';
import ImageDownloaderReview from './ImageDownloader/ImageDownloaderReview';
import ImageDownloaderAd from './ImageDownloader/ImageDownloaderAd';
import ContactGeneral from './ContactGeneral';
import PostContactGeneral from './PostContactGeneral';
import SurveyPage from './SurveyPage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAyjxNuqnIzLcvuHpID_QSWyBzMonm7Fuo",
  authDomain: "suricata-44947.firebaseapp.com",
  projectId: "suricata-44947",
  storageBucket: "suricata-44947.appspot.com",
  messagingSenderId: "933632047434",
  appId: "1:933632047434:web:d54eee5cc30e08b9a169b3",
  measurementId: "G-Y0M3W47Q4M"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

function App() {
  return (
    <div className="App">
      <div id="main-container">
      <NavBar />
      <Routes>
        <Route path='/survey/' element={< SurveyPage/>}/>
        <Route path='/print-rate_us/:browser/:lang' element={<PrintRateUs />} />
        <Route path='/image_downloader-rate_us/:browser/:lang' element={<ImageDownloaderRateUs />} />
        <Route path='/print-review/:browser/:msgIndex/:lang/:numOfPrints' element={<PrintReview />} />
        <Route path='/print_without_images-review/:browser/:msgIndex/:lang/:numOfPrints' element={<PrintWithoutImagesReview />} />
        <Route path='/' element={<Navigate to='/en/home' />} />
        <Route path='/no_swipe-get_code' element={<NoSwipeGetCode />} />
        <Route path='/image_downloader-get_code/:language' element={<ImageDownloaderGetCode />} />
        <Route path='/en/home' element={<Home />} />
        <Route path='/contact' element={<Navigate to='/contact/en' />} />
        <Route path='/en/contact' element={<Navigate to='/contact/en' />} />
        <Route path='/contact/:language' element={<ContactGeneral db={db} />} />
        <Route path='/post-contact/:language' element={<PostContactGeneral />} />
        <Route path='/en/uninstall_survey/:subject' element={< UninstallSurvey db={db}/>} />
        <Route path='/uninstall_survey/:subject/:language/:version' element={< UninstallSurveyGeneral db={db}/>} />
        <Route path='/en/print-review/:browser' element={< PrintRateUs/>} />
        <Route path='/print' element={<Navigate to='/en/print' />} />
        <Route path='/en/print' element={<Print />} />
        <Route path='/en/print-review-opera' element={<review/>} />
        <Route path='/print_without_images' element={<Navigate to='/en/print_without_images' />} />
        <Route path='/en/print_without_images' element={<PrintWithoutImages />} />
        <Route path='/no_swipe' element={<Navigate to='/en/no_swipe' />} />
        <Route path='/en/no_swipe' element={<NoSwipe />} />
        <Route path='/no_swipe-rate_us/:browser/:lang' element={<NoSwipeRateUs />} />
        <Route path='/image_downloader' element={<Navigate to='/image_downloader/en' />} />
        <Route path='/image_downloader/:language' element={<ImageDownloaderGeneral />} />
        <Route path='/sponge_color_picker/:language' element={<SpongeColorPicker />} />
        <Route path='/app-guide-sponge_color_picker/:language' element={<SpongeColorPicker />} />
        <Route path='/image_downloader-privacy_policy/:language' element={<ImageDownloaderPrivacyPolicy />} />
        <Route path='/app-save-image_downloader/:language' element={<ImageDownloaderGeneral />} />
        <Route path='/app-troubleshoot-image_downloader/:language' element={<ImageDownloaderGeneral />} />
        <Route path='/share-image_downloader/:language' element={<ImageDownloaderGeneral />} />
        <Route path='/app-guide-image_downloader/:language' element={<ImageDownloaderGeneral />} />
        <Route path='/survey-image_downloader-review/:browser/:msgIndex/:lang/:numOfDownloads' element={<ImageDownloaderReview />} />
        <Route path='/image_downloader-review/:browser/:msgIndex/:lang/:numOfPrints' element={<ImageDownloaderReview />} />
        <Route path='/image_downloader-ad/:browser/:msgIndex/:lang/:numOfPrints' element={<ImageDownloaderAd />} />
        <Route path='/en/image_downloader' element={<ImageDownloader />} />
      </Routes>
    </div>
    <br/>&nbsp;
        <br/>&nbsp;
        <br/>&nbsp;
        <br/>&nbsp;
        <br/>&nbsp;
        <br/>&nbsp;
        <br/>&nbsp;
        <br/>&nbsp;
        <br/>&nbsp;
        <br/>&nbsp;
    </div>
  );
}

export default App;
